import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const NotificationFilters = ({ filters, onFilterChange, notificationCounts }) => {
  const typeOptions = [
    { value: 'all', label: `All Types (${notificationCounts?.all || 0})` },
    { value: 'quote', label: `Quotes (${notificationCounts?.quote || 0})` },
    { value: 'milestone', label: `Milestones (${notificationCounts?.milestone || 0})` },
    { value: 'message', label: `Messages (${notificationCounts?.message || 0})` },
    { value: 'vendor', label: `Vendors (${notificationCounts?.vendor || 0})` }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'unread', label: `Unread (${notificationCounts?.unread || 0})` },
    { value: 'read', label: `Read (${notificationCounts?.read || 0})` }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleClearFilters = () => {
    onFilterChange({
      type: 'all',
      project: 'all',
      status: 'all',
      search: ''
    });
  };

  const hasActiveFilters = () => {
    return filters?.type !== 'all' || 
           filters?.status !== 'all' || 
           filters?.search !== '';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Search and Type Filter Row */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4">
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary"
            />
            <Input
              type="search"
              placeholder="Search notifications by project, vendor, or message..."
              value={filters?.search}
              onChange={(e) => handleFilterChange('search', e?.target?.value)}
              className="pl-10 w-full"
            />
          </div>
        </div>
        <div className="flex gap-3">
          <Select
            value={filters?.type}
            onChange={(e) => handleFilterChange('type', e?.target?.value)}
            options={typeOptions}
            className="min-w-[180px]"
          />
          <Select
            value={filters?.status}
            onChange={(e) => handleFilterChange('status', e?.target?.value)}
            options={statusOptions}
            className="min-w-[150px]"
          />
        </div>
      </div>

      {/* Quick Filter Buttons */}
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-text-secondary mr-2">Quick Filters:</span>
        <Button
          variant={filters?.type === 'quote' ? 'default' : 'outline'}
          size="sm"
          onClick={() => handleFilterChange('type', filters?.type === 'quote' ? 'all' : 'quote')}
          iconName="FileText"
          iconSize={14}
        >
          Quotes
        </Button>
        <Button
          variant={filters?.type === 'milestone' ? 'default' : 'outline'}
          size="sm"
          onClick={() => handleFilterChange('type', filters?.type === 'milestone' ? 'all' : 'milestone')}
          iconName="CheckCircle"
          iconSize={14}
        >
          Milestones
        </Button>
        <Button
          variant={filters?.type === 'message' ? 'default' : 'outline'}
          size="sm"
          onClick={() => handleFilterChange('type', filters?.type === 'message' ? 'all' : 'message')}
          iconName="MessageCircle"
          iconSize={14}
        >
          Messages
        </Button>
        <Button
          variant={filters?.type === 'vendor' ? 'default' : 'outline'}
          size="sm"
          onClick={() => handleFilterChange('type', filters?.type === 'vendor' ? 'all' : 'vendor')}
          iconName="Users"
          iconSize={14}
        >
          Vendors
        </Button>
        <Button
          variant={filters?.status === 'unread' ? 'default' : 'outline'}
          size="sm"
          onClick={() => handleFilterChange('status', filters?.status === 'unread' ? 'all' : 'unread')}
          iconName="Bell"
          iconSize={14}
        >
          Unread Only
        </Button>
        {hasActiveFilters() && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClearFilters}
            iconName="X"
            iconSize={14}
            className="ml-auto"
          >
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default NotificationFilters;